import { render } from "./template_list_all.vue?vue&type=template&id=5f97c637&scoped=true"
import script from "./templateListAllComponent.js?vue&type=script&lang=js"
export * from "./templateListAllComponent.js?vue&type=script&lang=js"

import "./template_list_all.vue?vue&type=style&index=0&id=5f97c637&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f97c637"]])

export default __exports__